import { useMemo } from 'react';
import { useForm, Mode } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { CountryCode } from 'typescript/constants/localization';
import {
  AddressType,
  createAddressFieldsSchema,
} from 'typescript/schemas/address_forms/address_fields';

interface UseAddressFormProps {
  addressType: AddressType;
  countryCode: CountryCode;
  validationMode?: Mode;
  reValidateMode?: Exclude<Mode, 'onTouched' | 'all'>;
}

const useAddressForm = ({
  addressType,
  countryCode,
  validationMode = 'onBlur', // default to onBlur validation
  reValidateMode = 'onBlur', // default to onBlur revalidation
}: UseAddressFormProps) => {
  const addressSchema = useMemo(() => {
    return createAddressFieldsSchema({
      addressType,
      countryCode,
    });
  }, []);

  const formMethods = useForm({
    mode: validationMode,
    reValidateMode,
    resolver: zodResolver(addressSchema),
  });

  return {
    addressSchema,
    formMethods,
  };
};

export default useAddressForm;
